import {
  AutoComplete,
  ISelectType,
  useFetch,
  useFormContext,
} from "@4uhub/lib4uhub";
import { Grid, Typography } from "@mui/material";
import { useEffect, useMemo, useRef, useState } from "react";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ticketChannelStep } from "../../../../../../services/ticketChannelStep.service";
import { TTicketAutoFinishRuleForm } from "./TicketAutoFinishRuleSchema";
import TicketChannel from "./TicketChannel";

const translationPath = "page.settings.crm.ticketAutoFinishRules.";

const TicketChannelStepTransfer = () => {
  const { t } = useTranslation();

  const { control } = useFormContext<TTicketAutoFinishRuleForm>();

  const [ticketChannelStepOptions, setTicketChannelStepOptions] = useState<
    ISelectType[]
  >([]);
  const lastFetchedTicketChannelTransferId = useRef<string | null>(null);

  const { sendRequest } = useFetch(ticketChannelStep);

  const ticketChannelTransfer = useWatch({
    name: "ticketChannelTransfer",
    control,
  });

  const ticketChannelStepSelected = useWatch({
    name: "ticketChannelStep",
    control,
  });

  useEffect(() => {
    if (!ticketChannelTransfer?.id) {
      lastFetchedTicketChannelTransferId.current = null;
      setTicketChannelStepOptions([]);
      return;
    }

    if (lastFetchedTicketChannelTransferId.current === ticketChannelTransfer.id) {
      return;
    }

    lastFetchedTicketChannelTransferId.current = ticketChannelTransfer.id;

    const fetchTicketChannelSteps = async () => {
      const { data, success } = await sendRequest({
        id: ticketChannelTransfer.id,
        onlyFinish: true,
      });

      if (data && success) {
        setTicketChannelStepOptions(data);
      }
    };

    fetchTicketChannelSteps();
  }, [sendRequest, ticketChannelTransfer]);

  const ticketChannelStepTransferOptions = useMemo(
    () =>
      ticketChannelStepSelected
        ? ticketChannelStepOptions.filter(
            (item) => item.id !== ticketChannelStepSelected.id,
          )
        : ticketChannelStepOptions,
    [ticketChannelStepOptions, ticketChannelStepSelected],
  );

  return (
    <Grid item xs={12} marginY={6}>
      <Typography variant="h6" sx={{ fontWeight: "bold", marginBottom: 2 }}>
        {t(translationPath + "move_finished_to") + ":"}
      </Typography>

      <Grid container spacing={2}>
        <TicketChannel
          name="ticketChannelTransfer"
          ticketChannelStepFieldName="ticketChannelStepTransfer"
        />

        <Grid item xs={12} sm={6}>
          <AutoComplete
            getOptionLabel={(option) => {
              return option.name;
            }}
            size="small"
            label={t(translationPath + "ticket_channel_step_transfer")}
            name="ticketChannelStepTransfer"
            options={ticketChannelStepTransferOptions}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default TicketChannelStepTransfer;
